import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import * as SC from "./BackToPrevPage.style";

/** @param {{ backLink?: import("react-router-dom").To | number; isMobile?: boolean; }} props */
export const BackToPrevPage = ({ backLink = -1, isMobile = false}) => {
  const navigate = useNavigate();

  return (
    <SC.Container
      title="Back to the previous page"
      // @ts-ignore
      onClick={() => navigate(backLink)}
    >
      <ArrowBackIosNewIcon fontSize="large" />
      {!isMobile && "Back"}
    </SC.Container>
  );
};
